/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgManageInventory = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 1.906 22 6.35v6.407l-.879-.878A2.988 2.988 0 0 0 20 11.17V7.65l-8-3.556L4 7.65V20h2V8h12v3.17c-.41.145-.794.381-1.121.709L14.757 14H8v2h4.757L11 17.757V18H8v2h3v2H2V6.35zM16 12v-2H8v2zm3.707 1.293a1 1 0 0 0-1.414 0L13 18.586V23h4.414l5.293-5.293a1 1 0 0 0 0-1.414zM15 21v-1.586l4-4L20.586 17l-4 4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgManageInventory as ManageInventory };
